import { forwardRef } from 'react';
import { Button as GardenButton } from '@zendeskgarden/react-buttons';
import type { GardenProps } from './interfaces';

export const Button = forwardRef<HTMLButtonElement, GardenProps>(
  ({ type = 'button', ...rest }, ref) => <GardenButton ref={ref} type={type} {...rest} />
);
Button.displayName = 'Button';
